import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useScreenSize, useCustomScreen } from "../Utils";

const SavingTypes = [
  {
    id: 1,
    name: "BASIC",
    price: "$180",
    additionalText: "$18.00 USD/ per report (10% savings)",
  },
  {
    id: 2,
    name: "STANDARD",
    price: "$270",
    additionalText: "$27.00 USD/ per report (10% savings)",
  },
  {
    id: 3,
    name: "COMPREHENSIVE",
    price: "$405",
    additionalText: "$40.50 USD/ per report (10% savings)",
  },
  {
    id: 4,
    name: "CLAIMS",
    price: "$315",
    additionalText: "$31.50 USD / per report (10% savings)",
  },
];

export default function SavingsSection() {
  const navigate = useNavigate(); 
  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();
  const { isIpadProPortrait } = useCustomScreen();

  function loginNavigateHandler() {
    localStorage.setItem("login-from", "Reports");
    const isUserAuthenticated = localStorage.getItem("token");
    if(isUserAuthenticated){
      navigate("/profile/credits-purchase") 
    }else{
  navigate("/login");
    }
  }
  return (
    // <section className="mb-5 p-0 mt-0 pb-0 pricing">
    //   <header className="section-header my-5 pt-4">
    //     <h3 style={{ color: "#4E585A" }}>Pre-order for savings</h3>
    //   </header>
    //   <div className="container">
    //     <div className="row row-cols-1 row-cols-md-3 row-cols-lg-3 mb-3 text-center">
    //       {SavingTypes.map((item) => {
    //         const { id, name, price, additionalText } = item;
    //         return (
    //           <div className="col" key={id}>
    //             <div className="card mb-3 rounded-3 shadow-sm">
    //               <div className="card-header pt-3 border-0 bg-white">
    //                 <h4 className="my-0 fw-normal d-flex flex-row fs-3">
    //                   {name}
    //                 </h4>
    //               </div>
    //               <div className="card-body" style={{ textAlign: "left" }}>
    //                 <h1 className="card-title pricing-card-title">
    //                   {price}
    //                   <small className="fs-5">/ per 10 pack of reports</small>
    //                 </h1>
    //                 <ul className="list-unstyled mt-3 mb-4 p-0">
    //                   <li className="p-0">{additionalText}</li>
    //                 </ul>
    //                 <button
    //                   type="submit"
    //                   className="buy-btn1 float-end"
    //                   onClick={() => {
    //                     loginNavigateHandler();
    //                   }}
    //                 >
    //                   Order
    //                 </button>
    //               </div>
    //             </div>
    //           </div>
    //         );
    //       })}
    //     </div>
    //   </div>
    // </section>
    <section className="mb-5 p-0 mt-0 pb-0 pricing">
      <header className="section-header my-5 pt-4">
        <h1
          style={{
            color: "#4E585A",
            fontWeight: "bold",
            textAlign: "center",
            fontSize: is4kScreen
              ? "5.3rem"
              : isXxlScreen
              ? "2.8rem"
              : isXlScreen
              ? "2.7rem"
              : isIpadProPortrait
              ? "3rem"
              : isLargeScreen
              ? "2.4rem"
              : isMediumScreen
              ? "2.4rem"
              : "2rem",
          }}
        >
          Pre-order for savings
        </h1>
      </header>
      <div className="container">
        <div
          className={`row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-${
            isIpadProPortrait ? "2" : "4"
          } mb-3 text-center`}
        >
          {SavingTypes.map((item) => {
            const { id, name, price, additionalText } = item;
            return (
              <div className="col" key={id}>
                <div className="card mb-3 rounded-3 shadow-sm">
                  <div className="card-header pt-3 border-0 bg-white">
                    <h4
                      className="my-0 fw-normal d-flex flex-row "
                      style={{
                        fontSize: is4kScreen
                          ? "2.3rem"
                          : isXxlScreen
                          ? "1.6rem"
                          : isXlScreen
                          ? "1.5rem"
                          : isIpadProPortrait
                          ? "2rem"
                          : isLargeScreen
                          ? "1.4rem"
                          : isMediumScreen
                          ? "1.6rem"
                          : "1.5rem",
                      }}
                    >
                      {name}
                    </h4>
                  </div>
                  <div className="card-body text-start">
                    <h1
                      className="card-title pricing-card-title"
                      style={{
                        fontSize: is4kScreen
                          ? "3.5rem"
                          : isXxlScreen
                          ? "2.4rem"
                          : isXlScreen
                          ? "2.3rem"
                          : isIpadProPortrait
                          ? "2.6rem"
                          : isLargeScreen
                          ? "2.2rem"
                          : "2rem",
                        paddinTop: is4kScreen
                          ? "1rem"
                          : isLargeScreen
                          ? "0.5rem"
                          : "",
                        paddingBottom: is4kScreen
                          ? "1rem"
                          : isLargeScreen
                          ? "0.5rem"
                          : "",
                      }}
                    >
                      {price} <span>USD</span>/
                      <small
                        className=""
                        style={{
                          fontSize: is4kScreen
                            ? "2rem"
                            : isXxlScreen
                            ? "1.2rem"
                            : isXlScreen
                            ? "1rem"
                            : isIpadProPortrait
                            ? "1.5rem"
                            : isLargeScreen
                            ? "1rem"
                            : "1.2rem",
                        }}
                      >
                        {" "}
                        per 10 pack of
                        {isIpadProPortrait ? (
                          ""
                        ) : isLargeScreen ? (
                          <br />
                        ) : (
                          ""
                        )}{" "}
                        reports
                      </small>
                    </h1>
                    <ul className="list-unstyled mt-3 mb-4 p-0">
                      <li
                        className="p-0"
                        style={{
                          fontSize: is4kScreen
                            ? "1.9rem"
                            : isXxlScreen
                            ? "1.2rem"
                            : isXlScreen
                            ? "1.0rem"
                            : isIpadProPortrait
                            ? "1.5rem"
                            : isLargeScreen
                            ? "1.1rem"
                            : isMediumScreen
                            ? "1rem"
                            : "",
                          paddingBottom: is4kScreen
                            ? "1rem"
                            : isLargeScreen
                            ? "0.5rem"
                            : "",
                        }}
                      >
                        {additionalText}
                      </li>
                    </ul>
                      <button
                        type="submit"
                        className=" float-end"
                        onClick={loginNavigateHandler}
                        style={{
                          fontSize: is4kScreen
                            ? "1.8rem"
                            : isXxlScreen
                            ? "1.2rem"
                            : isIpadProPortrait
                            ? "1.6rem"
                            : isLargeScreen
                            ? "0.9rem"
                            : "",
                          // padding: "0.5rem 0.8rem 0.5rem 0.8rem",
                          padding: "0.5rem",
                          width: is4kScreen ? "15rem" : "7rem",
                          borderRadius: is4kScreen ? "2rem" : "1.5rem",
                          border: "1px solid #57c0d1",
                          backgroundColor: "#bae5ec",
                        }}
                      >
                        Order
                      </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
